import API from "../config/api.js";

export const GoodsReturnService = {
  getBranches() {
    return API.get("/api/inventory/branches");
  },
  getSuppliersList() {
    return API.get("/api/inventory/suppliers");
  },
  getSuppliers(po_number) {
    return API.get(`/api/goods_return_note/list/suppliers/${po_number}`);
  },

  getBatchList(search) {
    return API.get(`/api/batch/list/se=${search}`);
  },
  getInvoiceList(search, page = 1) {
    return API.get(`api/invoices/list/se=${search}?page=${page}`);
  },
  getProducts() {
    return API.get("/api/inventory/products");
  },

  //create return note
  async createGrn(formData) {
    try {
      const response = await API.post(
        "/api/goods_return_note/create",
        formData
      );
      return response.data;
    } catch (error) {
      console.error("Error creating Goods Return Note:", error);
      throw error; // Rethrow error to handle it in the component
    }
  },

  getGrnList(search, page = 1) {
    return API.get(`/api/goods_return_note/list/se=${search}`, { params: { page: page }  });
  },

  async getGrnDetails(uuid) {
    try {
      const response = await API.get(`/api/goods_return_note/info/${uuid}`);
      return response.data.data; // Return the specific purchase order details
    } catch (error) {
      console.error("Error fetching Goods Return details:", error);
      throw error;
    }
  },

  async getItemsByGrnId(goods_return_id) {
    try {
      const response = await API.get(
        `/api/goods_return_note/info/items/${goods_return_id}`
      );
      return response.data.data;
    } catch (error) {
      console.error("Error fetching items by Goods Return ID:", error);
      throw error;
    }
  },

  //updating
  async updateGrn(id, formData) {
    try {
      const response = await API.put(
        `/api/goods_return_note/info/update/${id}`,
        formData
      );

      if (response.status === 200) {
        return response.data;
      } else {
        throw new Error("Unexpected response status: " + response.status);
      }
    } catch (error) {
      console.error("Error updating Goods Returns:", error);
      if (error.response) {
        console.error("API Response Error:", error.response.data);
      }
      throw error;
    }
  },
  getPurchaseOrders() {
    return API.get(`/api/purchaseorder/ponumber`);
  },
  async getItemsByPoNumber(po_number) {
    try {
      const response = await API.get(
        `/api/goods_return_note/get_grn_items/${po_number}`
      );
      return response.data;
    } catch (error) {
      console.error("Error fetching items by PO number:", error);
      throw error;
    }
  },

  getStockList(search) {
    return API.get(`/api/goods_return_note/list/stockList/se=${search}`);
  },
};
